// Espone il titolo umano dell'entità (già calcolato dai wrapper XxxTabs con fetch ?lite=1)
// al trail dei breadcrumb: il crumb della show mostra "Rossi Srl" invece di "Azienda #42".
import { getGroupKey } from '@/router/breadcrumbRegistry'

export default {
	watch: {
		entityTitle: {
			immediate: true,
			handler(title) {
				if (title) {
					this.$store.commit('setCrumbEntityLabel', {
						groupKey: getGroupKey(this.$route),
						label: title,
					})
				}
			},
		},
	},
}
